/**
 * Copyright (c) 2025 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Eugen Becker <e.becker@techdivision.com>
 */

import React from 'react';
import {Arrow} from './Arrow';

const sendToEmail = 'erdwaerme@energieversorgung-burghausen.de';
const sendToSubject = 'Anschlusswert meines Gebäudes';

export const ResultDisplay = ({ result }) => {
  if (!result) {
    return null;
  }

  return (
    <div className="result-container">
      <span className="result-label">Ihr Ergebnis</span>
      <div className="result-value">
        <strong className="value-label">Berechnete Hausanschlussleistung</strong>
        <Arrow />
        <div className="value-box">{result.connectionLoad} kW</div>
      </div>
      <span className="info-text">
        <strong>Bitte beachten Sie:</strong> Dies ist ein Näherungswert, der von den tatsächlichen Gegebenheiten abweichen kann.
        Der Anschlusswert beeinflusst sowohl einmalige Anschluss- als auch laufende Heizkosten.
      </span>
      <span className="info-text">
        <strong>Gut zu wissen:</strong> Durch den Einbau eines Pufferspeichers kann der Anschlusswert Ihrer Wärmeversorgung
        signifikant reduziert werden. Dies ermöglicht eine effizientere Auslegung des Netzanschlusses und trägt somit
        zur
        wirtschaftlichen Optimierung Ihrer Investition bei. Für eine verbindliche Planung und individuelle Beratung
        sprechen Sie mit
        Ihrem Heizungsbauer und Energieberater. So profitieren Sie nicht nur von einer technisch sinnvollen Lösung,
        sondern
        auch von spürbaren Kostenvorteilen.
      </span>
      <div className="btn-wrapper">
        <a className="btn btn-cta" href={`mailto:${sendToEmail}?subject=${sendToSubject}`}>
          <span className="btn-cta-text icon-arrow-right">JETZT KONTAKT AUFNEHMEN</span>
        </a>
      </div>
    </div>
  );
};
